type Props = {
  label: string
  value: number
  onChange: (value: number) => void
  min: number
  max: number
  step?: number
}

export default function SliderInput({
  label,
  value,
  onChange,
  min,
  max,
  step = 1
}: Props) {
  return (
    <div className="mt-4">
      <div className="flex justify-between mb-2">
        <label className="font-medium">{label}</label>
        <span className="text-sm text-gray-600">{value}</span>
      </div>

      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full"
      />
    </div>
  )
}